module.exports = __webpack_public_path__ + "img/5.c349bcd7.png";